import { downscale } from 'src/conf/scale';
import type { GachaThemeStyles } from '../gacha.theme';

/** Base path for this theme assets */
const folder = 'assets/ui/gacha/tanabata';

/** Assets for preload */
const preload = {
  gacha_button_en: `${folder}/buttons/gacha_button_en.png`,
  gacha_button_ja: `${folder}/buttons/gacha_button_ja.png`,
};

/** All assets for the theme */
const assets = {
  ...preload,
  gacha_popup: `${folder}/background/gacha_popup.png`,
  gacha_button_en: `${folder}/buttons/gacha_button_en.png`,
  gacha_button_ja: `${folder}/buttons/gacha_button_ja.png`,
  timer_bg: `${folder}/buttons/timer_bg.png`,
  shop_banner_en: `${folder}/frames/shop_banner_en.png`,
  shop_banner_ja: `${folder}/frames/shop_banner_ja.png`,
  title_en: `${folder}/icons/gacha_title_en.png`,
  title_ja: `${folder}/icons/gacha_title_ja.png`,
  intro_bg: `${folder}/intro/bg.png`,
  intro_title_en: `${folder}/icons/gacha_title_en.png`,
  intro_title_ja: `${folder}/icons/gacha_title_ja.png`,
  intro_subtitle_en: `${folder}/icons/limitedtimeonly_en.png`,
  intro_subtitle_ja: `${folder}/icons/limitedtimeonly_ja.png`,
};

/** View styles for the  theme */
const styles: GachaThemeStyles = {
  gacha_popup: ({ width, height }) => ({
    width: downscale(948),
    height: downscale(1743),
    x: width / 2,
    y: 530,
    image: assets.gacha_popup,
  }),
  gacha_popup_timer: () => ({
    color: '#FFFFFF',
    y: 710,
  }),
  gacha_button_en: () => ({
    image: assets.gacha_button_en,
  }),
  gacha_button_ja: () => ({
    image: assets.gacha_button_ja,
  }),
  timer_bg: () => ({
    image: assets.timer_bg,
  }),
  shop_banner_en: () => ({
    width: downscale(813),
    height: downscale(255),
    image: assets.shop_banner_en,
  }),
  shop_banner_ja: () => ({
    width: downscale(813),
    height: downscale(255),
    image: assets.shop_banner_ja,
  }),
  title_en: ({ titleY, titleX }) => ({
    y: titleY - 115,
    width: downscale(501),
    height: downscale(197),
    image: assets.title_en,
  }),
  title_ja: ({ titleY, titleX }) => ({
    y: titleY - 115,
    width: downscale(309),
    height: downscale(264),
    image: assets.title_ja,
  }),
  intro_bg: ({ width, height }) => ({
    width: downscale(1086),
    height: downscale(1519),
    y: 100,
    image: assets.intro_bg,
  }),
  intro_title_en: ({ titleY, titleX }) => ({
    x: 363,
    y: 160,
    width: downscale(501),
    height: downscale(197),
    image: assets.intro_title_en,
  }),
  intro_title_ja: ({ titleY, titleX }) => ({
    x: 363,
    y: 160,
    width: downscale(309),
    height: downscale(264),
    image: assets.intro_title_ja,
  }),
  intro_subtitle_en: ({ titleY }) => ({
    x: 130,
    y: titleY + 5,
    width: downscale(103),
    height: downscale(106),
    scale: 2,
    image: assets.intro_subtitle_en,
  }),
  intro_subtitle_ja: ({ titleY }) => ({
    x: 130,
    y: titleY + 5,
    width: downscale(103),
    height: downscale(106),
    scale: 2,
    image: assets.intro_subtitle_ja,
  }),
  intro_timer: ({ titleY }) => ({
    y: 620,
  }),
  intro_text: ({ height }) => ({
    y: 720,
    scale: 0.8,
    color: '#FFFFFF',
    font: 'Body',
  }),
  intro_button: ({ height }) => ({
    y: 910,
  }),
};

export const gachaThemeTanabata = {
  styles,
  assets,
  preload,
  folder,
};
